import { Facebook, Linkedin, Instagram } from 'lucide-react';
import { Button } from './ui/button';
import { toast } from 'sonner';

interface SocialShareProps {
  url: string;
  title: string;
  description?: string;
}

export const SocialShare = ({ url, title, description }: SocialShareProps) => {
  const shareToFacebook = (e: React.MouseEvent) => {
    e.stopPropagation();
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    window.open(facebookUrl, '_blank', 'width=600,height=400');
  };

  const shareToLinkedIn = (e: React.MouseEvent) => {
    e.stopPropagation();
    const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
    window.open(linkedInUrl, '_blank', 'width=600,height=400');
  };

  const shareToInstagram = (e: React.MouseEvent) => {
    e.stopPropagation();
    // Instagram doesn't support direct URL sharing from web
    // Copy URL to clipboard for manual sharing
    navigator.clipboard.writeText(url);
    toast.success('Link copied! Open Instagram app to share.');
  };

  return (
    <div className="flex items-center gap-2">
      <span className="text-xs text-muted-foreground mr-1">Share:</span>
      <Button
        variant="outline"
        size="sm"
        onClick={shareToFacebook}
        className="h-8 w-8 p-0"
        aria-label="Share on Facebook"
      >
        <Facebook className="w-3.5 h-3.5" />
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={shareToLinkedIn}
        className="h-8 w-8 p-0"
        aria-label="Share on LinkedIn"
      >
        <Linkedin className="w-3.5 h-3.5" />
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={shareToInstagram}
        className="h-8 w-8 p-0"
        aria-label="Copy link for Instagram"
      >
        <Instagram className="w-3.5 h-3.5" />
      </Button>
    </div>
  );
};